/* Swatch King -> USF price bridge (collection grid)
 *
 * The collection grid is rendered by Ultimate Search & Filter (USF, Vue).
 * Swatch King injects its swatches into each card and writes the chosen
 * variant id to the card's `swatch-current-variant` attribute, but it never
 * touches the price, because USF owns that markup (`collectionBlock-info`).
 *
 * USF's card component already knows how to price a variant via
 * `setSelectedVariantId` (price, compare-at strike, sale badge). This bridge
 * watches the attribute Swatch King writes and forwards it to USF, so the
 * price follows the selected swatch.
 *
 * Lives in the theme on purpose: `usf.js` is regenerated by the USF app and
 * any direct edit there is lost. No app bundle is modified. It does not
 * depend on USF events either: the attribute can only change once the card
 * exists, and by then its Vue instance is mounted on the element.
 */
(function () {
    var ATTR = 'swatch-current-variant';
    var CARD = '[data-collection-block]';

    if (!window.MutationObserver) return;

    function syncCard(card) {
        var id = card.getAttribute(ATTR);
        var vm = card.__vue__;
        if (!id || !vm || !vm.product || typeof vm.setSelectedVariantId !== 'function') return;

        var variants = vm.product.variants || [];
        var variant = null;
        for (var i = 0; i < variants.length; i++) {
            if (String(variants[i].id) === id) { variant = variants[i]; break; }
        }
        if (!variant || vm.product.selectedVariantId === variant.id) return;

        vm.setSelectedVariantId(variant.id);
    }

    function start() {
        new MutationObserver(function (mutations) {
            for (var i = 0; i < mutations.length; i++) {
                var target = mutations[i].target;
                if (target.nodeType === 1 && target.matches(CARD)) syncCard(target);
            }
        }).observe(document.body, { attributes: true, attributeFilter: [ATTR], subtree: true });

        // Cards that Swatch King already processed before this script ran.
        var cards = document.querySelectorAll(CARD + '[' + ATTR + ']');
        for (var i = 0; i < cards.length; i++) syncCard(cards[i]);
    }

    if (document.body) start();
    else document.addEventListener('DOMContentLoaded', start);
})();
